import { IntlShape } from 'react-intl';
import { Line } from 'src/interfaces/VesselScenario';
import { LineTypeHelpers, lineGroupKeys, lineTypeIdList, lineTypeIdShortList } from 'src/interfaces/LineType';

/**
 * To be used in conjunction with `getLineNames`, eg.
 * getLineNames(mooringArrangement, null, allStores.configStore.diagnosticsLineNames)
 */
const diagnosticsLineNames = {
  bowLine: 'Bow Line',
  foreBreastLine: 'Fore Breast Line',
  foreSpringLine: 'Fore Spring Line',
  aftSpringLine: 'Aft Spring Line',
  aftBreastLine: 'Aft Breast Line',
  sternLine: 'Stern Line',
};

const groupBy = (list: Line[], keyGetter: (row: Line) => number) => {
  const map: Map<number, Line[]> = new Map();

  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);

    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });

  return map;
};

export interface LineName {
  name: string;
  number: number;
}

const getLineNames = (
  lines: Line[],
  intl: IntlShape,
  short?: boolean,
  altLineNames?: { [key: string]: string },
): LineName[] => {
  const lineTypes = groupBy(lines, (row) => row.lineType);
  const lineNames: LineName[] = [];

  lineTypes.forEach((lineTypeSet) => {
    lineTypeSet.forEach((line: any, index: number) => {
      const lineName = altLineNames
        ? altLineNames[LineTypeHelpers.toLineTypeId(line.lineType)]
        : intl.formatMessage({
            id: short
              ? `components.ma.scenarioEditor.fields.mooring.lines.short.${LineTypeHelpers.toShortName(line.lineType)}`
              : `components.ma.scenarioEditor.fields.mooring.lines.long.${LineTypeHelpers.toLineTypeId(line.lineType)}`,
          });

      lineNames[line.id] = { name: lineName, number: index + 1 };
    });
  });

  return lineNames;
};

export { diagnosticsLineNames, getLineNames, lineGroupKeys, lineTypeIdList };
